// extracted by css-extract-rspack-plugin
export default {"container":"_668db408","link":"_5760878f","selected":"_4e195806"};